module.exports = __webpack_public_path__ + "img/cs-logo.fbf3da39.svg";